import React, { Fragment, Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { change as changeFieldValue, Field, formValueSelector, reduxForm } from 'redux-form';
import {
    renderFieldNumber,
    renderFieldDataNascimento,
    renderFieldSelect,
    ano,
    renderFieldPlacaVeiculo,
    placa,
    required,
    renderFieldRenavam,
} from '../../util/inputs';
import Titulo from '../comum/Titulo';
import { getAdminEmpresa, getFiscalEmbarque, getOperadorEmpresa, getGestorOperacoes, PERFIL_ADMIN } from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import { isAmbienteDev, tamanhoArquivoUpload } from '../../util/applicationContext';
import cadastrarVeiculo from '../../actions/veiculo/cadastrarVeiculo'
import buscarVeiculos from '../../actions/veiculo/buscarVeiculos';
import alterarVeiculo from '../../actions/veiculo/alterarVeiculo'
import { showSuccessMsg } from '../../util/messagesUtil';
import ModalSelecionarMapaVeiculo from './ModalSelecionarMapaVeiculo';
import MapaVeiculo from '../mapa-veiculo/MapaVeiculo';
import alterarMapaSelecionadoVeiculo from '../../actions/veiculo/alterarMapaSelecionadoVeiculo';
import { campoTipoVeiculo } from '../../util/constantsUtil';
import moment from 'moment'
import CheckboxGroupTipoServico from './CheckboxGroupTipoServico';
import { gerarHashForString } from '../../util/stringUtil';
import ImageGridUpload from './ImageGridUpload';
import Modal from './Modal';

export const validate = (values) => {
    const errors = {};
    if (!values.nome) {
        errors.nome = 'Campo obrigatório'
    }
    if (!values.tipo) {
        errors.tipo = 'Campo obrigatório'
    }
    if (!values.qtdPoltronas) {
        errors.qtdPoltronas = 'Campo obrigatório'
    }
    if (!values.posicaoPorta) {
        errors.posicaoPorta = 'Posição da porta obrigatória.'
    }

    return errors
};

export function ehDataValida(value) {
    if (value && value !== '__/__/____' && !moment(value, 'DD/MM/YYYY', true)
        .isValid()) {
        return 'Data inválida'
    }
    return undefined
}

const renderField = ({
    input,
    label,
    type,
    css,
    max,
    readOnly,
    meta: { touched, error }
}) => (
    <div>
        <label className='mt-2'>{label}</label>
        <div>
            <input {...input} type={type}
                className={css}
                maxLength={max}
                style={{ borderColor: touched && error ? 'red' : '' }}
                disabled={readOnly}
                readOnly={readOnly} />
            {touched
                && (error && <span style={{ color: 'red' }}>{error}</span>)}
        </div>
    </div>
);

const LIMITE_UPLOAD_ARQUIVO = 7;

export class PainelCadastrarVeiculo extends Component {
    constructor(props) {
        super(props);
        this.limparFormulario = this.limparFormulario.bind(this);
        this.handleChange = this.handleChange.bind(this)
        this.state = {
            mensagens: [],
            veiculoSelecionado: null,
            tipoVeiculo: null,
            tipoServico: [],
            arquivos: [],
            selectedImg: null,
        };
    }

    handleTipoVeiculo(e) {        
        this.setState({ tipoVeiculo: e.value });
    }

    handleCheckboxGroup(valores) {
        if (valores) {
            const array = valores.map(it => it ? it.chave : null);
            this.setState({ tipoServico: array });
        }
    }

    componentDidMount() {
        this.props.alterarMapaSelecionadoVeiculo(null);
        this.carregarFormulario();
    }

    carregarFormulario() {
        this.props.changeFieldValue('formularioPainelCadastroVeiculo',
            'mapaVeiculo', this.props.veiculoSelecionado.mapaVeiculoDto);
        this.props.changeFieldValue('formularioPainelCadastroVeiculo',
            'descricao', this.props.veiculoSelecionado.descricao);
        this.props.changeFieldValue('formularioPainelCadastroVeiculo',
            'idVeiculo', this.props.veiculoSelecionado.id);
        this.props.changeFieldValue('formularioPainelCadastroVeiculo',
            'idRastreamento', this.props.veiculoSelecionado.idRastreamento);
        this.props.changeFieldValue('formularioPainelCadastroVeiculo',
            'base64Veiculo', this.props.veiculoSelecionado.base64Veiculo);
        this.props.changeFieldValue('formularioPainelCadastroVeiculo',
            'urlImagem', this.props.veiculoSelecionado.urlImagem);

        this.props.changeFieldValue('formularioPainelCadastroVeiculo',
            'placa', this.props.veiculoSelecionado.placa);

        this.props.changeFieldValue('formularioPainelCadastroVeiculo',
            'modelo', this.props.veiculoSelecionado.modelo);

        this.props.changeFieldValue('formularioPainelCadastroVeiculo',
            'tipoVeiculo', this.props.veiculoSelecionado.tipoVeiculo ? {
                label: this.props.veiculoSelecionado.tipoVeiculo.valor,
                value: this.props.veiculoSelecionado.tipoVeiculo.chave
            } : null);

        this.props.changeFieldValue('formularioPainelCadastroVeiculo',
            'quilometragem', this.props.veiculoSelecionado.quilometragem);

        this.props.changeFieldValue('formularioPainelCadastroVeiculo',
            'renavam', this.props.veiculoSelecionado.renavam);

        this.props.changeFieldValue('formularioPainelCadastroVeiculo',
            'anoFabricacao', this.props.veiculoSelecionado.anoFabricacao);

        this.props.changeFieldValue('formularioPainelCadastroVeiculo',
            'numeroEixo', this.props.veiculoSelecionado.numeroEixo);

        this.props.changeFieldValue('formularioPainelCadastroVeiculo',
            'dataVencimentoCsv', this.props.veiculoSelecionado.dataVencimentoCsv);

        this.props.changeFieldValue('formularioPainelCadastroVeiculo',
            'chassi', this.props.veiculoSelecionado.chassi);

        this.props.alterarMapaSelecionadoVeiculo(this.props.veiculoSelecionado.mapaVeiculoDto);


        if (this.props.veiculoSelecionado.imagens) {
            const imagens = this.props.veiculoSelecionado.imagens.map(it => {
                return {
                    hash: gerarHashForString(`${it.nome}`),
                    ...it
                }
            });
            this.setState({ arquivos: imagens });
        }

    }

    // eslint-disable-next-line class-methods-use-this
    exibirBotaoNovoVeiculo() {
        if (!this.props.empresaSelecionada) {
            return ''
        }
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getGestorOperacoes(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                <div className="row">
                    <div className="col-md-12">
                        <div className="text-left">
                            <button data-toggle="modal" data-target="#modalSelecionarMapaVeiculo" className="btn btn-laranja"
                                onClick={() => this.selecionarTipoVeiculoParaMapaVeiculo()}>
                                Selecionar modelo de veículo
                            </button>
                        </div>
                    </div>
                </div>
            </Autorizacao>
        )
    }

    selecionarTipoVeiculoParaMapaVeiculo() {
        const first = campoTipoVeiculo.find(it => it.chave == this.state.tipoVeiculo);
        if (first) {
            this.props.changeFieldValue('formularioMapasVeiculos', 'tipo', {
                label: first.valor,
                value: first.chave
            });
        }
    }

    selecionarMapa() {
        if (this.props.mapaSelecionadoVeiculo) {
            this.props.alterarMapaSelecionadoVeiculo(null);
            this.props.changeFieldValue('formularioPainelCadastroVeiculo',
                'mapaVeiculo', null);
        }
    }

    getTotalAssentosPorAndar(andar) {
        const fileiras = andar == 1 ? this.props.mapaSelecionadoVeiculo.fileirasPrimeiroAndar : this.props.mapaSelecionadoVeiculo.fileirasSegundoAndar
        let total = 0;
        for (let chave in fileiras) {
            let fileira = fileiras[chave];
            fileira.assentos.forEach(it => {
                if (it.tipoAssento === 'NORMAL') {
                    total++;
                }
            });
        }

        return total;
    }

    exibirTotalPoltronasPorAndar() {
        return <><label>1° andar - Quantidade poltronas: {this.getTotalAssentosPorAndar(1)}</label><br />
            {<label>2° andar - Quantidade poltronas: {this.getTotalAssentosPorAndar(2)}</label>}</>
    }

    exibirMapas() {
        if (this.props.mapaSelecionadoVeiculo) {
            return <>
                <label>Total Poltronas: {this.props.mapaSelecionadoVeiculo.quantidadeAssentos}</label><br />
                {this.props.mapaSelecionadoVeiculo.seDoisAndares && this.exibirTotalPoltronasPorAndar()}

                <MapaVeiculo mapaVeiculo={this.props.mapaSelecionadoVeiculo} selecionar={this.selecionarMapa.bind(this)}
                    selecionado={this.props.mapaSelecionadoVeiculo} />
            </>
        }

        return '';
    }

    handleChange(event) {
        const chooseFiles = Array.prototype.slice.call(event.target.files);
        const arquivos = [...this.state.arquivos];

        const mensagens = [];
        
        const mensagem = {
            tipo: 'erro',
            nomeArquivo: '',
            texto: 'Limite excedido de arquivos para upload.'
        };

        if (chooseFiles.length > LIMITE_UPLOAD_ARQUIVO) {
            mensagem.nomeArquivo = chooseFiles[chooseFiles.length -1].name;
            mensagens.push(mensagem);
            this.setState({ mensagens });            
            return;
        }
        
        const limite = arquivos.length + chooseFiles.length;

        chooseFiles.forEach(file => {
            if (arquivos.findIndex(arq => arq.nome === file.name) === -1) {
                if (/\.(jpe?g|png|webp)$/i.test(file.name) === false) {
                    const mensagem = {
                        tipo: 'erro',
                        nomeArquivo: file.name,
                        texto: 'Formato de imagem inválido. Informe uma imagem nos formatos JPEG, PNG ou JPG.'
                    };
                    mensagens.push(mensagem);
                } else if (limite >= 0 && arquivos.length > LIMITE_UPLOAD_ARQUIVO) {
                    const mensagem = {
                        tipo: 'erro',
                        nomeArquivo: file.name,
                        texto: 'Limite excedido de arquivos para upload.'
                    };
                    mensagens.push(mensagem);
                    return;
                } else if (file.size > tamanhoArquivoUpload) {
                    const mensagem = {
                        tipo: 'erro',
                        nomeArquivo: file.name,
                        texto: 'Tamanho do arquivo excede 20 MB.'
                    };
                    mensagens.push(mensagem);
                } else {   
                    this.converterParaBase64(file);
                }
            }
        })

        this.setState({ mensagens });
    }

    converterParaBase64(file) {
        const obj = {
            hash: gerarHashForString(`${file.name}`),
            nome: file.name,
            base64Veiculo: null,
            urlImagem: null,
            principal: false            
        };

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {            
            const arquivos = [...this.state.arquivos];
            obj.base64Veiculo = reader.result;
            obj.urlImagem = reader.result;
            obj.principal = arquivos.length <= 0 && true
            arquivos.push(obj);

            this.setState({ arquivos });
        }.bind(this);
        reader.onerror = function () {
            const mensagem = {
                tipo: 'erro',
                nomeArquivo: file.name,
                texto: 'Imagem inválida. Selecione outra imagem.'
            };
            const mensagens = [...this.state.mensagens];
            mensagens.push(mensagem);
            this.setState({ mensagens });
            this.removerImagem(obj);
        }.bind(this);
    }

    setImagemPrincipal(file) {
        const arquivos = [...this.state.arquivos];
        arquivos.forEach(it => {
            it. principal = false;
        })

        arquivos.forEach(it => {
            if (file.hash === it.hash) {
              it.principal = true;
              return;
            }            
        })

        this.setState({ arquivos });
    }

    exibirImagem() {
        return (
            <>
                {this.state.arquivos.length > 0 && <p>Selecione a imagem principal</p>}
                {this.state.arquivos.map((arq, index) => (
                    <Fragment key={`file-${index}`}>
                        <ImageGridUpload key={`file-${index}`} setSelectedImg={this.setSelectedImg.bind(this)} file={arq} removerImagem={this.removerImagem.bind(this)} setImagemPrincipal={this.setImagemPrincipal.bind(this)} />
                    </Fragment>
                ))}

                {this.state.selectedImg && <Modal selectedImg={this.state.selectedImg} setSelectedImg={this.setSelectedImg.bind(this)} />}
            </>
        )

    }

    removerImagem(arquivo) {
        const arquivos = [...this.state.arquivos];        
        const array = arquivos.filter(it => it.hash != arquivo.hash);

        if(arquivo.principal && array.length > 0) {
            array[0].principal = true;
        }

        this.setState({ arquivos: array });
    }

    setSelectedImg(selectedImg) {
        this.setState({ selectedImg })
    }

    limparMensagem() {
        this.setState({ mensagens: [] });
    }

    recuperaMensagem() {
        return this.state.mensagens.map((mensagem, index) => {
            if (mensagem.tipo === 'sucesso') {
                return (
                    <div key={`${mensagem.nomeArquivo}-${index}`} className="alert alert-success col-md-12">
                        {mensagem.texto}
                        <button type="button" className="close" aria-label="Close"
                            onClick={() => {
                                this.limparMensagem();
                            }
                            }>
                            <i className="material-icons">
                                &#xe5cd;
                            </i>
                        </button>
                    </div>
                )
            }
            if (mensagem.tipo === 'erro') {
                return (
                    <div key={`${mensagem.nomeArquivo}-${index}`} className="alert alert-danger col-md-12">
                        {mensagem.texto}
                        <button type="button" className="close" aria-label="Close"
                            onClick={() => {
                                this.limparMensagem();
                            }
                            }>
                            <i className="material-icons">
                                &#xe5cd;
                            </i>
                        </button>
                    </div>
                )
            }
        })
    }

    salvar() {
        const parametros = {
            id: this.props.idVeiculo,
            descricao: this.props.descricao,
            empresaId: this.props.empresaSelecionada.id,
            mapaVeiculoId: this.props.mapaSelecionadoVeiculo && this.props.mapaSelecionadoVeiculo.id,
            idRastreamento: this.props.idRastreamento,            
            placa: this.props.placa,
            modelo: this.props.modelo,
            tipoVeiculo: this.state.tipoVeiculo ? this.state.tipoVeiculo : this.props.tipoVeiculo && this.props.tipoVeiculo.value,
            quilometragem: this.props.quilometragem,
            renavam: this.props.renavam,
            chassi: this.props.chassi,
            anoFabricacao: this.props.anoFabricacao,
            numeroEixo: this.props.numeroEixo,
            dataVencimentoCsv: this.props.dataVencimentoCsv,
            tipoServico: this.state.tipoServico.filter(it => it != null),
            imagens: this.state.arquivos

        };

        if (this.props.idVeiculo) {
            this.props.alterarVeiculo(parametros)
                .then(() => {
                    this.limparFormulario();
                    this.props.buscarVeiculos(this.props.empresaSelecionada.id);
                    this.props.history.push('/painel-veiculos');
                    showSuccessMsg('Veiculo alterado com sucesso');
                })
        } else {
            this.props.cadastrarVeiculo(parametros)
                .then(() => {
                    this.limparFormulario();
                    this.props.history.push('/painel-veiculos');
                    showSuccessMsg('Veiculo cadastrada com sucesso');
                    this.props.buscarVeiculos(this.props.empresaSelecionada.id);
                })
        }
    }

    limparFormulario() {
        this.props.reset('formularioPainelCadastroVeiculo');
        this.props.alterarMapaSelecionadoVeiculo(null);
    }

    naoEhEmbarcacao() {
        return ((this.props.tipoVeiculo && this.props.tipoVeiculo.value != 'EMBARCACAO') || this.state.tipoVeiculo !=  'EMBARCACAO');
    }

    render() {
        const {invalid} = this.props;

        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getGestorOperacoes(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getFiscalEmbarque(this.props.empresaSelecionada.id)]}>
                <div>
                    <div className="row internas">
                        <Titulo texto={`Painel ${this.props.idVeiculo ? 'Editar' : 'Cadastrar'} Veículo`} urlRetorno="/painel-veiculos" />
                        <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                            {this.recuperaMensagem()}
                            <div className="modal-body">
                                <div className="form-row">
                                    <div className="col-12 col-sm-4 col-md-4">
                                        <Field name='tipoVeiculo'
                                            options={campoTipoVeiculo.map(elemento => ({
                                                descricao: elemento.valor,
                                                nome: elemento.chave
                                            }))}                                            
                                            onChange={(e) => this.handleTipoVeiculo(e)}
                                            component={renderFieldSelect}
                                            label='Tipo:'
                                            placeholder='Selecione...'
                                        />
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="col-12 col-sm-9 col-md-9">
                                        <Field name="descricao" type="text" component={renderField}
                                            validate={[required]}
                                            label="Descrição:"
                                            css="form-control" readOnly={false} />
                                    </div>
                                    {isAmbienteDev() ? <div className="col-12 col-sm-3 col-md-3">
                                        <Field name="idRastreamento" type="text" component={renderFieldNumber}
                                            formatacao="#######"
                                            label="Identificador de rastreamento:"
                                            css="form-control" />
                                    </div> : ''}
                                </div>
                                <div className='input-wrapper mt-3'>
                                    <label htmlFor='input-file'>
                                        {this.props.logoMarca ? 'Alterar imagens veículo' : 'Adicionar imagens veículo'}
                                    </label>
                                    <input id='input-file' type='file' value='' accept="image/*" onChange={this.handleChange.bind(this)} multiple />
                                    <span id='file-name' />
                                </div>
                                <div className='img-grid mt-4'>
                                    {this.exibirImagem()}
                                </div>
                                <div className='mt-3'>
                                    {this.props.mapaSelecionadoVeiculo ? <> <h3 className='text-center'>Selecionar modelo de veículo</h3> {this.exibirMapas()} </>
                                        : this.exibirBotaoNovoVeiculo()}
                                </div>

                               {this.naoEhEmbarcacao() && <><div className="form-row">
                                        <div className="col-12 col-sm-3 col-md-3">
                                            <Field name="placa" type="text" component={renderFieldPlacaVeiculo}                                        
                                                max={8}
                                                label="Placa:"
                                                css="form-control" readOnly={false}
                                                validate={[placa]} />
                                        </div>
                                        <div className="col-12 col-sm-5 col-md-5">
                                            <Field name="modelo" type="text" component={renderField}
                                                label="Modelo:"
                                                css="form-control" readOnly={false} />
                                        </div>
                                        
                                    </div>

                                    <div className="form-row">
                                        <div className="col-12 col-sm-3 col-md-3">
                                            <Field name="renavam" type="text" component={renderFieldRenavam}
                                                max={11}
                                                label="Renavam:"
                                                css="form-control" readOnly={false} />
                                        </div>
                                        <div className="col-12 col-sm-4 col-md-4">
                                            <Field name="chassi" type="text" component={renderField}
                                                max={17}
                                                label="Chassi:"
                                                css="form-control" readOnly={false} />
                                        </div>
                                        <div className="col-12 col-sm-2 col-md-2">
                                            <Field name="anoFabricacao" type="text" component={renderFieldNumber}
                                                formatacao="####"
                                                validate={[ano]}
                                                label="Ano de Fabricação:"
                                                css="form-control" readOnly={false} />
                                        </div>
                                        <div className="col-12 col-sm-3 col-md-3">
                                            <Field name="quilometragem" component={renderFieldNumber}
                                                formatacao="#######"
                                                label="Quilometragem:"
                                                css="form-control" readOnly={false} />
                                        </div>
                                    </div>

                                    <div className="form-row">                                    
                                        <div className="col-12 col-sm-4 col-md-4">
                                            <Field name="numeroEixo" type="text" component={renderFieldNumber}
                                                formatacao="##"
                                                label="N° Eixos:"
                                                css="form-control" readOnly={false} />
                                        </div>
                                        <div className="col-12 col-sm-3 col-md-3">
                                            <Field name="dataVencimentoCsv" type="text" component={renderFieldDataNascimento}
                                                validate={[ehDataValida]}
                                                label="Data Vencimento CSV:"
                                                css="form-control" readOnly={false} />
                                        </div>
                                    </div>

                                    <div className="form-row mt-4">
                                        <div className="col-12 col-sm-8 col-md-8">
                                            <div style={{ overflowRight: '10px' }}>
                                                <CheckboxGroupTipoServico tipoServico={this.props.veiculoSelecionado.tipoServico}
                                                    handleValues={this.handleCheckboxGroup.bind(this)} />
                                            </div>
                                        </div>
                                    </div>
                                </>}

                                <div className="modal-footer mt-2">
                                    <button type="submit"
                                        disabled={!this.props.descricao || !this.props.mapaSelecionadoVeiculo ||invalid} onClick={() => this.salvar()}
                                        className="btn btn-laranja">Salvar
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                    <ModalSelecionarMapaVeiculo veiculo={this.props.veiculoSelecionado} />
                </div>
            </Autorizacao>
        )
    }
}


export const mapStateToProps = state => {
    return {
        descricao: formValueSelector('formularioPainelCadastroVeiculo')(state, 'descricao'),
        mapaVeiculo: formValueSelector('formularioPainelCadastroVeiculo')(state, 'mapaVeiculo'),
        idVeiculo: formValueSelector('formularioPainelCadastroVeiculo')(state, 'idVeiculo'),
        idRastreamento: formValueSelector('formularioPainelCadastroVeiculo')(state, 'idRastreamento'),
        base64Veiculo: formValueSelector('formularioPainelCadastroVeiculo')(state, 'base64Veiculo'),
        urlImagem: formValueSelector('formularioPainelCadastroVeiculo')(state, 'urlImagem'),

        placa: formValueSelector('formularioPainelCadastroVeiculo')(state, 'placa'),
        modelo: formValueSelector('formularioPainelCadastroVeiculo')(state, 'modelo'),
        tipoVeiculo: formValueSelector('formularioPainelCadastroVeiculo')(state, 'tipoVeiculo'),
        quilometragem: formValueSelector('formularioPainelCadastroVeiculo')(state, 'quilometragem'),
        renavam: formValueSelector('formularioPainelCadastroVeiculo')(state, 'renavam'),
        chassi: formValueSelector('formularioPainelCadastroVeiculo')(state, 'chassi'),
        anoFabricacao: formValueSelector('formularioPainelCadastroVeiculo')(state, 'anoFabricacao'),
        numeroEixo: formValueSelector('formularioPainelCadastroVeiculo')(state, 'numeroEixo'),
        dataVencimentoCsv: formValueSelector('formularioPainelCadastroVeiculo')(state, 'dataVencimentoCsv'),

        empresaSelecionada: state.empresaSelecionada,
        mapaSelecionadoVeiculo: state.mapaSelecionadoVeiculo,
        veiculoSelecionado: state.veiculoSelecionado
    }
};

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        cadastrarVeiculo,
        alterarVeiculo,
        alterarMapaSelecionadoVeiculo,
        buscarVeiculos
    }, dispatch)
);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioPainelCadastroVeiculo',
    validate
})(PainelCadastrarVeiculo)))